import {HTMLAttributes} from 'react';
import {theme} from '../../../theme';
import {Divider} from '../../atoms/Divider/Divider';

type DialogDividerProps = HTMLAttributes<HTMLDivElement>;

export function DialogDivider(props: DialogDividerProps) {
  return (
    <Divider
      direction="horizontal"
      sizePx={1}
      color={theme.colors['theme-transparent-20']}
      {...props}
    />
  );
}

export const DialogDividerType = (<DialogDivider />).type;
